// extracted by mini-css-extract-plugin
module.exports = {"previousNextSelector":"OBTPreviousNextSelector_previousNextSelector__2scHi"};